__turbopack_context__.v({
  "className": "m_plus_1p_180b6bf7-module__XnmLFW__className",
  "variable": "m_plus_1p_180b6bf7-module__XnmLFW__variable",
});
